import { Module } from "vuex";
import axios from "@/plugins/axios";
import { RootState } from "@/store";
import { AxiosResponse } from "axios";
import { Form } from "@/interfaces";

interface FormState {
  forms: Array<Form>;
}

const form: Module<FormState, RootState> = {
  namespaced: true,
  state: {
    forms: [],
  },
  mutations: {
    setForms(state, payload) {
      const { forms } = payload;
      state.forms = forms;
    },
  },
  actions: {
    getForms({ commit }) {
      axios
        .get("/api/forms")
        .then((response: AxiosResponse<{ forms: Array<Form> }>) =>
          commit("setForms", { forms: response.data.forms })
        )
        .catch((error) => error);
    },
  },
  getters: {
    allForms(state): Array<Form> {
      const forms = state.forms.filter((form) => form.isOpen === true);
      return forms;
    },
    pulseForms(state): Array<Form> {
      const forms = state.forms
        .filter((form) => form.tool.name === "Pulso")
        .filter((form) => form.isOpen === true);
      return forms;
    },
    rulerForms(state): Array<Form> {
      const forms = state.forms
        .filter((form) => form.tool.name === "Régua de Desempenho")
        .filter((form) => form.isOpen === true);
      return forms;
    },
    aqcForms(state): Array<Form> {
      const forms = state.forms
        .filter((form) => form.tool.name === "AQC")
        .filter((form) => form.isOpen === true);
      return forms;
    },
    pcoForms(state): Array<Form> {
      const forms = state.forms
        .filter((form) => form.tool.name === "PCO")
        .filter((form) => form.isOpen === true);
      return forms;
    },
    av360Forms(state): Array<Form> {
      const forms = state.forms
        .filter((form) => form.tool.name === "AV360")
        .filter((form) => form.isOpen === true);
      return forms;
    },
  },
};

export default form;
